import React, { useState, useEffect } from "react";
import "./../../components/style/Connexion.css";
import Connexion from "./Connexion";
import Home from "../home/Home";
import Inscription from "./Inscription";
import { useTranslation } from "react-i18next";
import useAuth from "../../hooks/useAuth";

const Root = () => {
  const [connexion, setConnexion] = useState(false);
  const [inscription, setInscription] = useState(false);
  const [home, setHome] = useState(false);
  const { user, loading, logout } = useAuth();
  const { t } = useTranslation();
  const LOGO_IMG = "/rm_imgs/Logo.png";

  // Au premier rendu, la session est vérifiée via GET /auth/me : si un
  // utilisateur est connecté, on va directement à son espace.
  useEffect(() => {
    if (!loading && user) {
      setHome(true);
    }
  }, [loading, user]);

  /**
   * Affiche la liste des parcours si une session existe sinon la page de connexion
   */
  const handleConnexion = () => {
    if (user) {
      setHome(true);
    } else {
      setConnexion(true);
    }
  };

  /**
   * Affiche la liste des parcours si une session existe sinon la page d'inscription
   */
  const handleInscription = () => {
    if (user) {
      setHome(true);
    } else {
      setInscription(true);
    }
  };

  if (connexion) {
    return <Connexion />;
  }
  if (inscription) {
    return <Inscription />;
  }

  if (home && user) {
    return (
      <Home
        userData={{ ...user, _id: user.id, id: user.id }}
        setUserData={() => {}}
        logout={logout}
      />
    );
  }

  return (
    <div className="App text-center">
      <div className="AppContainer d-flex  flex-column align-items-center justify-content-center ">
        <form className="accessPage">
          <div className="logoContainer mb-5 d-flex flex-column align-items-center justify-content-center">
            <img src={LOGO_IMG} alt="Logo RoadMaker" className="logo mb-4" />
          </div>

          <div className="buttonsContainer d-flex flex-column">
            {!user && (
              <button
                aria-label="btn-inscription"
                className="btnMenu"
                onClick={() => handleInscription()}
              >
                {t("inscription")}
              </button>
            )}
            <button
              className="btnMenu mt-2"
              aria-label="btn-connexion"
              onClick={() => handleConnexion()}
            >
              {user ? t("home") : t("connexion")}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Root;
